import { render, staticRenderFns } from "./mOverlay.vue?vue&type=template&id=9fafd90e&scoped=true"
import script from "./mOverlay.vue?vue&type=script&lang=ts"
export * from "./mOverlay.vue?vue&type=script&lang=ts"
import style0 from "./mOverlay.vue?vue&type=style&index=0&id=9fafd90e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fafd90e",
  null
  
)

export default component.exports